
const Shop = ({ articlecategories: _articlecategories }) => {
    return null;
}

export default Shop;
